export enum CouplingStatus {
  Coupled = 0,
  PendingApproval = 1,
  BlockedNoEmail = 2,
}

export enum ApprovalStatus {
  Approved = 0,
  Rejected = 1,
  Expired = 2,
  AlreadyProcessed = 3,
  Invalid = 4,
}

export interface CouplingResultDto {
  status: CouplingStatus;
}

export interface ApprovalResultDto {
  status: ApprovalStatus;
  // E-mailadres van de aanvragende mijnAssist-gebruiker (enkel bij Approved/Rejected).
  requesterEmail?: string;
}

// Een fiche die de gebruiker kan koppelen op basis van zijn geverifieerde account-e-mailadres.
// Ter selectie getoond in de MijnAssist-modal; personId dient als selectie-identifier richting
// coupleByEmail (die de selectie server-side opnieuw valideert).
export interface MatchablePersonDto {
  personId: number;
  firstName: string;
  lastName: string;
}
